import { RegexOption } from 'src/shared/constants/regex-formats/types/RegexTypes';

const today = new Date();
const todayYear = today.getFullYear();
const todayMonth = today.getMonth() + 1;
const todayDay = today.getDate();

const months = [
  {
    full: 'January',
    short: 'Jan',
    military: 'JAN',
    numeric: '01',
  },
  {
    full: 'February',
    short: 'Feb',
    military: 'FEB',
    numeric: '02',
  },
  {
    full: 'March',
    short: 'Mar',
    military: 'MAR',
    numeric: '03',
  },
  {
    full: 'April',
    short: 'Apr',
    military: 'APR',
    numeric: '04',
  },
  {
    full: 'May',
    short: 'May',
    military: 'MAY',
    numeric: '05',
  },
  {
    full: 'June',
    short: 'Jun',
    military: 'JUN',
    numeric: '06',
  },
  {
    full: 'July',
    short: 'Jul',
    military: 'JUL',
    numeric: '07',
  },
  {
    full: 'August',
    short: 'Aug',
    military: 'AUG',
    numeric: '08',
  },
  {
    full: 'September',
    short: 'Sep',
    military: 'SEP',
    numeric: '09',
  },
  {
    full: 'October',
    short: 'Oct',
    military: 'OCT',
    numeric: '10',
  },
  {
    full: 'November',
    short: 'Nov',
    military: 'NOV',
    numeric: '11',
  },
  {
    full: 'December',
    short: 'Dec',
    military: 'DEC',
    numeric: '12',
  },
];

export const dateRegexOptions: RegexOption[] = [
  {
    type: 'date-eu-slash',
    code: 'DD/MM/YYYY',
    display: 'Date EU Slash',
    icon: 'Calendar',
    regex: '^(?:0[1-9]|[12]\\d|3[01])/(?:0[1-9]|1[0-2])/(?:19|20)\\d{2}$',
    examples: [
      `${todayDay.toString().padStart(2, '0')}/${todayMonth.toString().padStart(2, '0')}/${todayYear}`,
      '01/01/2024',
      '31/12/2024',
    ],
  },
  {
    type: 'date-eu-dash',
    code: 'DD-MM-YYYY',
    display: 'Date EU Dash',
    icon: 'Calendar',
    regex: '^(?:0[1-9]|[12]\\d|3[01])-(?:0[1-9]|1[0-2])-(?:19|20)\\d{2}$',
    examples: [
      `${todayDay.toString().padStart(2, '0')}-${todayMonth.toString().padStart(2, '0')}-${todayYear}`,
      '01-01-2024',
      '31-12-2024',
    ],
  },
  {
    type: 'date-eu-dot',
    code: 'DD.MM.YYYY',
    display: 'Date EU Dot',
    icon: 'Calendar',
    regex: '^(?:0[1-9]|[12]\\d|3[01])\\.(?:0[1-9]|1[0-2])\\.(?:19|20)\\d{2}$',
    examples: [
      `${todayDay.toString().padStart(2, '0')}.${todayMonth.toString().padStart(2, '0')}.${todayYear}`,
      '01.01.2024',
      '31.12.2024',
    ],
  },
  {
    type: 'date-uk-long',
    code: 'DD Month YYYY',
    display: 'Date UK Long',
    icon: 'Calendar',
    regex:
      '^(?:0[1-9]|[12]\\d|3[01])\\s(?:January|February|March|April|May|June|July|August|September|October|November|December)\\s(?:19|20)\\d{2}$',
    examples: [
      `${todayDay.toString().padStart(2, '0')} ${months[todayMonth - 1].full} ${todayYear}`,
      '01 January 2024',
      '31 December 2024',
    ],
  },
  {
    type: 'date-military-compact',
    code: 'DDMMMYYYY',
    display: 'Date Military Compact',
    icon: 'Calendar',
    regex: '^(?:0[1-9]|[12]\\d|3[01])(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)(?:19|20)\\d{2}$',
    examples: [
      `${todayDay.toString().padStart(2, '0')}${months[todayMonth - 1].military}${todayYear}`,
      '01JAN2024',
      '31DEC2024',
    ],
  },
  {
    type: 'date-military-spaced',
    code: 'DD MMM YYYY',
    display: 'Date Military Spaced',
    icon: 'Calendar',
    regex: '^(?:0[1-9]|[12]\\d|3[01])\\s(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)\\s(?:19|20)\\d{2}$',
    examples: [
      `${todayDay.toString().padStart(2, '0')} ${months[todayMonth - 1].military} ${todayYear}`,
      '01 JAN 2024',
      '31 DEC 2024',
    ],
  },
  {
    type: 'date-iso',
    code: 'YYYY-MM-DD',
    display: 'Date ISO',
    icon: 'Calendar',
    regex: '^(?:19|20)\\d{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\\d|3[01])$',
    examples: [
      `${todayYear}-${todayMonth.toString().padStart(2, '0')}-${todayDay.toString().padStart(2, '0')}`,
      '2024-01-01',
      '2024-12-31',
    ],
  },
  {
    type: 'date-us-slash',
    code: 'MM/DD/YYYY',
    display: 'Date US Slash',
    icon: 'Calendar',
    regex: '^(?:0[1-9]|1[0-2])/(?:0[1-9]|[12]\\d|3[01])/(?:19|20)\\d{2}$',
    examples: [
      `${todayMonth.toString().padStart(2, '0')}/${todayDay.toString().padStart(2, '0')}/${todayYear}`,
      '01/01/2024',
      '12/31/2024',
    ],
  },
  {
    type: 'date-us-dash',
    code: 'MM-DD-YYYY',
    display: 'Date US Dash',
    icon: 'Calendar',
    regex: '^(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\\d|3[01])-(?:19|20)\\d{2}$',
    examples: [
      `${todayMonth.toString().padStart(2, '0')}-${todayDay.toString().padStart(2, '0')}-${todayYear}`,
      '01-01-2024',
      '12-31-2024',
    ],
  },
  {
    type: 'date-us-long',
    code: 'Month DD, YYYY',
    display: 'Date US Long',
    icon: 'Calendar',
    regex:
      '^(?:January|February|March|April|May|June|July|August|September|October|November|December)\\s(?:0[1-9]|[12]\\d|3[01]),\\s(?:19|20)\\d{2}$',
    examples: [
      `${months[todayMonth - 1].full} ${todayDay.toString().padStart(2, '0')}, ${todayYear}`,
      'January 01, 2024',
      'December 31, 2024',
    ],
  },
];
